import type { AddNodeAction } from "../../../../schemas/index.ts";
import {
  addConditionAction,
  addEffectAction,
  addHandlerAction,
  addResponseAction,
  addTriggerAction,
} from "../triggerActions.ts";
export const getAddNodeDerivedActions = (action: AddNodeAction) => {
  const {
    payload: { node },
  } = action;
  if (!node.triggers) {
    return [];
  }

  const { id: nodeId, triggers } = node;

  const actions = [
    ...triggers.map((deets) => addTriggerAction({ nodeId, ...deets })),
    ...triggers.flatMap(({ id: triggerId, handlers }) =>
      handlers.flatMap(({ id: handlerId, label: handlerLabel, cases: handlerCases, responses }) => [
        addHandlerAction({ triggerId, id: handlerId, label: handlerLabel, cases: handlerCases }),
        ...responses.flatMap(({ id: responseId, label, effects, condition }) => [
          addResponseAction({ handlerId, id: responseId, label }),
          ...effects.map((effect) => addEffectAction({ responseId, effect })),
          ...(condition ? [addConditionAction({ to: { responseId }, condition })] : []),
        ]),
      ]),
    ),
  ];

  return actions;
};
